import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const CTA = () => {
  useEffect(() => {
    // Dynamically load the script when the component mounts
    // This ensures the container #sayify-widget-container exists in the DOM
    const script = document.createElement('script');
    script.src = "https://resource.sayify.pro/cdn/widget.js";
    script.setAttribute('data-slug', 'customer-inquiry');
    script.setAttribute('data-mode', 'inline-form');
    script.setAttribute('data-base-url', 'https://forms.crcnu.com');
    script.setAttribute('data-label', 'Feedback');
    script.setAttribute('data-color', '#C86A4A');
    script.setAttribute('data-position', 'bottom-right');
    script.setAttribute('data-description', 'Share your feedback by voice');
    script.setAttribute('data-inline-height', '600');
    script.setAttribute('data-auto-height', 'true');
    script.setAttribute('data-container', 'sayify-widget-container');
    script.async = true;

    const container = document.getElementById('sayify-widget-container');
    if (container) {
      container.appendChild(script);
    }

    return () => {
      // Cleanup script if component unmounts
      if (container && container.contains(script)) {
        container.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="contact" className="relative py-24 bg-blue-600 overflow-hidden">
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Ready to Upgrade Your Network?
          </h2>
          <p className="text-xl text-blue-100 mb-10">
            Contact Clark-Ritchotte Communications today for a free consultation. Let's discuss lowering your internet costs and building a faster, more secure network for your NYC business.
          </p>
          
          <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-2xl mx-auto text-left overflow-hidden">
            
            
            {/* Sayify Widget Container - Inline Form Target */}
            <div 
              id="sayify-widget-container" 
              className="w-full min-h-[600px] rounded-xl bg-slate-50 transition-all duration-500"
            >
              {/* The widget script will inject the form here */}
              
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;